import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

@Component
export default class AggMixin extends Vue {
  @Prop({ type: String }) date!: string;

  @Watch("date", { immediate: true })
  onDateChange() {
    this.agg();
  }


  public agg() {}
}
